export class ApplicationSummary {
    id: number;
    applicationId: string;
    applicationName: string;
    applicationDescription: string;
    url: string;
    roles: string;
    extOrganisationId: string;
    organisationName: string;
    email: string;
    isDefault: string;
    fromDate: Date;
    toDate: Date;
    position: string;
    organisationStatusCode: string;
    roleCode: string;
    applicationStatusCode: string;
    notification: string;
    isDioceseOffice: boolean;
}


// WEBPACK FOOTER //
// ./src/app/models/applicationSummary.ts